// Pile-table comic hover — modal kind. Centre-display table with a loose
// pile of comics, split into right + left stacks; only the top of each
// stack is hoverable. Suppressed while a pile-arc animation is mid-flight
// (the comic that was just clicked is sliding into its hero position).

import { registerInteractable } from "../_interactable-registry.js";
import { addOutline, removeOutline } from "../helpers.js";

registerInteractable({
	id: "pile-table",
	precedence: 80,
	// ASK-137 §84 — THIS KIND'S OWN PROMPT AND SUBJECT. `stage.js` used to enumerate every kind by
	// hand, twice (`_updateEHint`'s hover ladder and `_hoveredProduct`), which is exactly what the
	// registry's own header says a registry exists to end. The prompt a shopper reads and the product
	// it names belong where the rest of this kind's behaviour already is.
	hoverHint: '<kbd>E</kbd> Pick Up',
	productOf(stage, active) {
		return active?.product ?? active?.mesh?.userData?.interactable?.product ?? stage.hoveredPileComic?.userData?.interactable?.product ?? null;
	},

	suppressedBy(stage) {
		if (stage.boxState === "open" || stage.boxState === "browsing" || stage.boxState === "hero") return true;
		if (stage.activeFixtureHero) return true;
		if (stage.activeVinylBin)    return true;
		if (stage.activeStackTable)  return true;
		if (!stage.pileComics?.length) return true;
		if (stage.pileArcAnim)         return true;
		return false;
	},

	// Custom hit-test: only the top of each stack is hoverable. Walk the two
	// candidates and return the first that the raycast actually hits — same
	// short-circuit the legacy code used.
	evaluateActive(stage) {
		const topCandidates = [];
		if (stage.pileRightStack.length > 0) topCandidates.push(stage.pileRightStack[stage.pileRightStack.length - 1]);
		if (stage.pileLeftStack.length  > 0) topCandidates.push(stage.pileLeftStack[stage.pileLeftStack.length - 1]);
		for (const topIdx of topCandidates) {
			const hits = stage.raycaster.intersectObjects([stage.pileComics[topIdx].mesh], false);
			if (hits.length) return { topIdx, mesh: stage.pileComics[topIdx].mesh };
		}
		return null;
	},

	commitHover(stage, prev, next) {
		const prevMesh = prev?.mesh ?? null;
		const nextMesh = next?.mesh ?? null;
		if (prevMesh === nextMesh) return;
		if (prevMesh) removeOutline(prevMesh);
		stage.hoveredPileComic = nextMesh;
		if (nextMesh) addOutline(nextMesh);
	},

	interactE(stage, active) {
		if (!active || stage.pileArcAnim) return false;
		stage.setPileHero(active.topIdx);
		return true;
	},
});
